import React, {forwardRef} from 'react'

const NewEventBox = forwardRef(({...root}, ref) => {
  return <div ref={ref} className={`event-box event-box--new`} {...root}></div>
})

export default NewEventBox
